import { GzAiFeedbackWebComponent } from './component/GzAiFeedbackWebComponent';

export { GzAiFeedbackWebComponent };
